import type { AppState } from './types.ts';
import { INITIAL_STATE } from './types.ts';

const STORAGE_KEY = 'wasteManagementApp';

export const saveToStorage = (state: AppState): void => {
  try {

    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));

    // Also save individual keys for mcdaResults page compatibility
    localStorage.setItem('selectedCountry', state.selectedCountry || '');
    localStorage.setItem('selectedRegion', state.selectedRegion || '');
    localStorage.setItem('selectedDistrict', state.selectedDistrict || '');
    localStorage.setItem('selectedObjective', state.selectedObjective || '');
    localStorage.setItem('selectedWasteCategory', state.selectedWasteCategory || '');
    localStorage.setItem('selectedWasteType', state.selectedWasteType || '');
    localStorage.setItem('selectedBusinessModel', state.selectedBusinessModel || '');
    localStorage.setItem('selectedBusinessModels', JSON.stringify(state.selectedBusinessModels || []));
    localStorage.setItem('plantLocation', JSON.stringify(state.plantLocation || null));
  } catch (error) {
    console.error('Failed to save to localStorage:', error);
  }
};

export const loadFromStorage = (): AppState => {
  try {
    console.log('LOAD - keys:', Object.keys(localStorage));
    console.log('LOAD - STORAGE_KEY:', localStorage.getItem(STORAGE_KEY));
    
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsedState = JSON.parse(stored);
      console.log('LOAD SUCCESS:', parsedState);
      // Migration: force fuel type to Diesel (only supported fuel)
      const merged = { ...INITIAL_STATE, ...parsedState } as AppState;
      if (merged.plantSettings) {
        const needsMigration = (merged.plantSettings as any).selectedFuel !== "Diesel";
        if (needsMigration) {
          merged.plantSettings = { ...merged.plantSettings, selectedFuel: "Diesel" };
          try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
          } catch {}
        }
      }
      return merged;
    } else {
      console.log('❌ NO DATA FOUND');
    }
  } catch (error) {
    console.error('Failed to load from localStorage:', error);
  }
  return INITIAL_STATE;
};


export const clearStorage = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);

    // Also clear individual keys
    localStorage.removeItem('selectedCountry');
    localStorage.removeItem('selectedRegion');
    localStorage.removeItem('selectedObjective');
    localStorage.removeItem('selectedWasteCategory');
    localStorage.removeItem('selectedWasteType');
    localStorage.removeItem('selectedBusinessModel');
    localStorage.removeItem('selectedBusinessModels');
    localStorage.removeItem('plantLocation');
  } catch (error) {
    console.error('Failed to clear localStorage:', error);
  }
};
